import Tab from 'portaltransparencia-common/components/Tab.react.js';
import Tabs from 'portaltransparencia-common/components/Tabs.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import FormDetailInformacoesAdicionais from './FormDetailInformacoesAdicionais.react';
import FormDetailDotacoes from './FormDetailDotacoes.react';
import FormDetailPlanosTrabalhos from './FormDetailPlanosTrabalhos.react';
import FormDetailAnexos from './FormDetailAnexos.react';
import FormDetailMovimentacoes from './FormDetailMovimentacoes.react';
import FormDetailEntidadesBeneficiadas from './FormDetailEntidadesBeneficiadas.react';
import FormDetailLocalidadesBeneficiadas from './FormDetailLocalidadesBeneficiadas.react';
import FormDetailLicitacoes from './FormDetailLicitacoes.react';
import { TipoEmendaParlamentar } from '../TipoEmendaParlamentar';

function hasInformacoesAdicionaisData(informacaoAdicional) {
  if (!informacaoAdicional) return false;

  const convenio = informacaoAdicional.get('convenio');
  const contrato = informacaoAdicional.get('contrato');
  const licitacao = informacaoAdicional.get('licitacao');
  const contaBancaria = informacaoAdicional.get('contaBancaria');

  const hasConvenio =
    convenio &&
    (convenio.get('numero') ||
      convenio.get('ano') ||
      convenio.getIn(['beneficiario', 'pessoa', 'nome']));
  const hasContrato =
    contrato &&
    (contrato.get('numeroContrato') ||
      contrato.get('anoContrato') ||
      contrato.getIn(['fornecedor', 'nome']));
  const hasLicitacao =
    licitacao && (licitacao.get('numeroLicitacao') || licitacao.get('ano'));
  const hasContaBancaria =
    contaBancaria &&
    (contaBancaria.get('conta') || contaBancaria.get('descricao'));

  return !!(
    hasConvenio ||
    hasContrato ||
    hasLicitacao ||
    hasContaBancaria ||
    informacaoAdicional.get('numeroProcesso') ||
    informacaoAdicional.get('tipoLicitacao') ||
    informacaoAdicional.get('tipoFaseTransferencia')
  );
}

export function FormDetailTabs({
  emenda,
  tipo,
  isIntegradoOxy,
  licitacoesTotalElements
}) {
  const isEmendaMunicipal = tipo === TipoEmendaParlamentar.MUNICIPAL;

  const showInformacoesAdicionais =
    !isIntegradoOxy ||
    !isEmendaMunicipal ||
    hasInformacoesAdicionaisData(emenda.get('informacaoAdicional'));

  const showLicitacoes =
    isIntegradoOxy &&
    (!isEmendaMunicipal || licitacoesTotalElements > 0);

  return (
    <Tabs id="tabs">
      {showInformacoesAdicionais && (
        <Tab
          onlyTable
          tableResponsive
          title="Informações Adicionais"
          active={true}
        >
          <FormDetailInformacoesAdicionais
            informacaoAdicional={emenda.get('informacaoAdicional')}
            tipo={tipo}
            isIntegradoOxy={isIntegradoOxy}
          />
        </Tab>
      )}

      <Tab onlyTable tableResponsive title="Classificação Orçamentária">
        <FormDetailDotacoes dotacoes={emenda.get('dotacoes')} />
      </Tab>

      <Tab onlyTable tableResponsive title="Plano de Trabalho">
        <FormDetailPlanosTrabalhos
          planosTrabalhos={emenda.get('planosTrabalhos')}
          tipo={tipo}
          isIntegradoOxy={isIntegradoOxy}
        />
      </Tab>

      <Tab onlyTable tableResponsive title="Movimentação" renderOnlyWhenActive>
        <FormDetailMovimentacoes idEmenda={emenda.get('id')} />
      </Tab>

      {(isIntegradoOxy || isEmendaMunicipal) && (
        <Tab
          onlyTable
          tableResponsive
          title="Entidades Beneficiadas"
          renderOnlyWhenActive
        >
          <FormDetailEntidadesBeneficiadas idEmenda={emenda.get('id')} />
        </Tab>
      )}

      {(isIntegradoOxy || isEmendaMunicipal) && (
        <Tab
          onlyTable
          tableResponsive
          title="Localidades Beneficiadas"
          renderOnlyWhenActive
        >
          <FormDetailLocalidadesBeneficiadas idEmenda={emenda.get('id')} />
        </Tab>
      )}

      {showLicitacoes && (
        <Tab
          onlyTable
          tableResponsive
          title="Licitações"
          renderOnlyWhenActive
        >
          <FormDetailLicitacoes idEmenda={emenda.get('id')} />
        </Tab>
      )}

      <Tab onlyTable tableResponsive title="Documentos">
        <FormDetailAnexos anexos={emenda.get('documentos')} />
      </Tab>
    </Tabs>
  );
}

FormDetailTabs.propTypes = {
  emenda: PropTypes.object.isRequired,
  tipo: PropTypes.oneOf(Object.values(TipoEmendaParlamentar)).isRequired,
  isIntegradoOxy: PropTypes.bool,
  licitacoesTotalElements: PropTypes.number
};
